(function () {
  function initCart(root) {
    if (root.dataset.cartBound === 'true') return;
    root.dataset.cartBound = 'true';
    var loading = root.querySelector('[data-cart-loading]') || document.querySelector('[data-cart-loading]');

    function setLoading(active) {
      if (loading) loading.hidden = !active;
      document.documentElement.style.overflow = active ? 'hidden' : '';
    }

    function changeLine(line, quantity) {
      setLoading(true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Erro ao atualizar');
          return response.json();
        })
        .then(function () { window.location.reload(); })
        .catch(function () {
          setLoading(false);
          window.alert('Não foi possível atualizar a quantidade. Tente novamente.');
        });
    }

    root.querySelectorAll('[data-quantity-control]').forEach(function (control) {
      var input = control.querySelector('[data-qty-input]');
      var minus = control.querySelector('[data-qty-minus]');
      var plus = control.querySelector('[data-qty-plus]');
      if (!input) return;
      if (minus) minus.addEventListener('click', function () { changeLine(input.dataset.line, Number(input.value) - 1); });
      if (plus) plus.addEventListener('click', function () { changeLine(input.dataset.line, Number(input.value) + 1); });
      input.addEventListener('change', function () { changeLine(input.dataset.line, input.value); });
    });

    var discountButton = root.querySelector('[data-discount-apply]');
    var discountInput = root.querySelector('[data-discount-input]');
    var discountMessage = root.querySelector('[data-discount-message]');
    function applyDiscount() {
      var code = discountInput ? discountInput.value.trim() : '';
      if (!code) {
        if (discountMessage) {
          discountMessage.textContent = 'Digite um cupom para aplicar.';
          discountMessage.hidden = false;
        }
        if (discountInput) discountInput.focus();
        return;
      }
      window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=/cart');
    }
    if (discountButton) discountButton.addEventListener('click', applyDiscount);
    if (discountInput) discountInput.addEventListener('keydown', function (event) { if (event.key === 'Enter') { event.preventDefault(); applyDiscount(); } });

    root.querySelectorAll('[data-cart-upsell]').forEach(function (button) {
      button.addEventListener('click', function () {
        setLoading(true);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.cartUpsell), quantity: 1 }] })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Erro ao adicionar');
            return response.json();
          })
          .then(function () { window.location.reload(); })
          .catch(function () {
            setLoading(false);
            window.alert('Não foi possível adicionar o complemento. Tente novamente.');
          });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cart-commerce]').forEach(initCart);
  });
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-cart-commerce]').forEach(initCart);
  });
})();
